import { render } from "./SuccessInvoicePayment.vue?vue&type=template&id=31d2aeee"
import script from "./SuccessInvoicePayment.vue?vue&type=script&lang=js"
export * from "./SuccessInvoicePayment.vue?vue&type=script&lang=js"

import exportComponent from "D:\\server\\www\\greativ\\ui\\template\\superSkypark\\moduleTmpl\\shop\\VueBasket\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__